<template>
  <main
    id="main_div"
    ref="mainDiv"
  >
    <a
      class="btn_close"
      @click="closeDetail"
    />

    <StoreImages
      :store="store"
      :img-class="'details-img'"
    />

    <nav class="secondary_nav sticky_horizontal_2">
      <div class="container">
        <ul class="clearfix">
          <li>
            <b-link
              v-scroll-to="'#description'"
              href="#"
              class="active"
            >
              {{ $t('lang.stores.description') }}
            </b-link>
          </li>
          <li>
            <b-link
              v-scroll-to="'#reviews'"
              href="#"
            >
              {{ $t('lang.stores.reviews') }}
            </b-link>
          </li>
        </ul>
      </div>
    </nav>

    <div class="container margin_30">
      <button
        id="booking_button"
        ref="bookingButton"
        type="button"
        :class="['btn_1 rounded fixed_button', bookingIsDisabled ? 'disabled' : '']"
        :disabled="bookingIsDisabled"
        :style="{ left: bookingButtonLeft }"
        @click="bookingSubmitted"
      >
        <strong>{{ bookingButtonText }}</strong>
      </button>

      <div class="row">
        <div class="col-lg-12">
          <section id="description">
            <div class="detail_title_1">
              <h6>
                <!--                {{ $t('lang.categories.'+ store.category_id).toUpperCase() }}-->

                <div class="centered-content float-right">
                  <small class="mr-1">  {{ $t('lang.stores.verified_store') }}</small>
                  <i class="fa-solid fa-circle-check text-success" />
                </div>
              </h6>
              <h2 class="color_text">
                {{ store.name }}
              </h2>

              <div
                v-if="store.is_locker"
                class="alert alert-warning "
              >
                <p class="m-0">
                  <i class="fas fa-lock" />
                  <span v-html="$t('lang.lockers.store_description')" />
                </p>
              </div>

              <p
                class="mt-4 mb-0"
                style="font-size: 1rem"
              >
                <i class="fa-solid fa-location-dot" />
                &nbsp;{{ $t('lang.search.exact_location') }}
              </p>

              <div style="font-size: 1rem">
                <WalkingDistance :distance-in-km="store.distance" />
                <StoreReputation
                  v-if="store.reviews_scoring"
                  :scoring="this.store.reviews_scoring"
                  :reviews="store.total_reviews"
                />
              </div>
            </div>

            <LockerOptions
              v-if="store.is_locker"
              :lockers="store.lockers"
              :search-params="searchParams"
              @lockerSelectionChanged="lockersSelected"
            />

            <StoreSchedule
              :store="store"
              :search-params="searchParams"
            />

            <StoreServices :store="store" />
          </section>
          <!-- /section -->
          <hr>

          <section
            v-if="store.last_reviews.length"
            id="reviews"
          >
            <h5>{{ $t('lang.stores.reviews') }}</h5>
            <div class="mb-5">
              <StoreReviewsCarousel :reviews="store.last_reviews" />
            </div>
            <!--            <div-->
            <!--              v-else-->
            <!--              class="text-center"-->
            <!--              style="margin: 25px 0 80px 0"-->
            <!--            >-->
            <!--              <div class=" col-12 col-md-10 centered">-->
            <!--                <p-->
            <!--                  style="font-size: .875rem; margin-bottom: 1.5rem"-->
            <!--                  v-html="$t('lang.stores.no_reviews_secure_store', {store: this.store.name})"-->
            <!--                />-->
            <!--              </div>-->
            <!--            </div>-->

            <!-- /review-container -->
          </section>
          <!-- /section -->
        </div>
        <!-- /col -->
      </div>
      <!-- /row -->
    </div>
    <!-- /container -->
  </main>
</template>

<script>
import StoreImages from '@/components/Store/StoreImages';
import StoreServices from './StoreServices';
import StoreSchedule from './StoreSchedule';
import StoreReviewsCarousel from './StoreReviewsCarousel';
import LockerOptions from '@/components/Store/LockerOptions.vue';
import WalkingDistance from '@/components/Store/WalkingDistance.vue';
import StoreReputation from '@/components/Store/StoreReputation.vue';
import { getStoreBookingAdjustment } from '@/utils/storeSchedule';

export default {
  name: 'StoreDetails',

  components: {
    StoreReputation,
    WalkingDistance,
    LockerOptions,
    StoreReviewsCarousel,
    StoreSchedule,
    StoreImages,
    StoreServices,
  },

  props: {
    store: {
      type: Object,
      required: true,
    },
    searchParams: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      bookingButtonLeft: '10px',
      lockers: [],
    };
  },
  computed: {
    storeBookingAdjustment() {
      return getStoreBookingAdjustment(
        this.store,
        this.searchParams,
        this.$store.state.main.currency || 'USD',
      );
    },

    canBookWithAdjustment() {
      return Boolean(this.storeBookingAdjustment);
    },

    bookingIsDisabled() {
      if (!this.store.isAvailable && !this.canBookWithAdjustment) {
        return true;
      }
      if (this.store.is_locker && this.lockers.length === 0) {
        return true;
      }
      return false;
    },

    bookingButtonText() {
      if (this.store.is_locker && this.lockers.length === 0) {
        return this.$t('lang.lockers.select_locker');
      }

      if (this.storeBookingAdjustment && this.storeBookingAdjustment.startHour) {
        return `${this.$t('lang.stores.book')} ${this.$t('lang.stores.schedule_texts.from')} ${this.storeBookingAdjustment.startHour} ${this.$t('lang.stores.schedule_texts.to')} ${this.storeBookingAdjustment.endHour} hs`;
      }

      if (this.storeBookingAdjustment && this.storeBookingAdjustment.currency) {
        return `${this.$t('lang.stores.book')} ${this.$t('lang.stores.schedule_texts.in')} ${this.currencyText(this.storeBookingAdjustment.currency)}`;
      }

      if (this.bookingIsDisabled) {
        return this.$t('lang.stores.reserve_unavailable');
      }

      return this.$t('lang.stores.reserve');
    },

  },

  watch: {
    store() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.updateBookingButtonPosition();
    },

    bookingIsDisabled() {
      this.updateBookingButtonPosition();
    },

    bookingButtonText() {
      this.updateBookingButtonPosition();
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    window.addEventListener('resize', this.updateBookingButtonPosition);
    this.updateBookingButtonPosition();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateBookingButtonPosition);
  },
  methods: {
    updateBookingButtonPosition() {
      // centers the booking button every time there is a change in window size or button text.
      this.$nextTick(() => {
        const { mainDiv } = this.$refs;
        const { bookingButton } = this.$refs;

        if (!mainDiv || !bookingButton) {
          return;
        }

        const mainDivRect = mainDiv.getBoundingClientRect();
        const left = mainDivRect.left + (mainDivRect.width / 2) - (bookingButton.clientWidth / 2);

        this.bookingButtonLeft = `${left}px`;
      });
    },

    closeDetail() {
      this.$emit('close', this.store);
      // alert("store id emmit");
    },

    bookingSubmitted() {
      this.$emit('bookingSubmitted', this.storeBookingAdjustment);
    },

    currencyText(currency) {
      const prices = this.$globalPrices[currency];
      const symbol = prices && prices.symbol ? prices.symbol : `$ ${currency}`;

      return `${symbol}`;
    },

    lockersSelected(data) {
      this.lockers = data;
      this.$emit('lockerSelectionChanged', data);
    },
  },
};
</script>

<style scoped>
.fixed_button {
  max-width: calc(100vw - 30px);
}

.fixed_button.disabled{
  background-color: #959595 !important;
  border-color: #c1c1c1 !important;
  opacity: 1;
}

</style>
